import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const CustomSlider = ({ handleSliderChange, labelText, isChecked }) => {
  const [isOn, setIsOn] = useState(false);

  useEffect(() => {
    if(isChecked){
      setIsOn(true);
    } else {
      setIsOn(false)
    }
  }, [isChecked])

  const toggleSliderChange = () => {
    const newValue = !isOn;
    setIsOn(newValue);
    handleSliderChange(newValue);
  };

  return (
    <Form.Group className="d-flex align-items-center">
      <div>
        <span className="me-3">{labelText}</span>
      </div>
      <div style={{marginTop: '1px'}}>
        <Form.Check
          size={"xl"}
          type="switch"
          id="customSwitch"
          checked={isOn}
          onChange={toggleSliderChange}
        />
      </div>
    </Form.Group>
  );
};

export default CustomSlider;
